export interface DtoAddress {
    id: number;
    address1: string | null;
    address2: string | null;
    city: string | null;
    zipCode: string | null;
    stateProvince: string | null;
    /** Display / user-entered country (maps to API countryFullName) */
    countryFullName: string | null;
    /** ISO from API when round-tripping; not the primary signup field */
    country: string | null;
}


export function createDtoAddress(obj?: DtoAddress | any) {
    const result = <DtoAddress>{
        id: 0,
        address1: null,
        address2: null,
        city: null,
        zipCode: null,
        stateProvince: null,
        countryFullName: null,
        country: null
    };

    if (obj) {
        Object.assign(result, obj);
    }
    return result;
}